import { Card, Col, ProgressBar, Stack } from "react-bootstrap";

import LoadingIndicator from "../LoadingIndicator";
import ErrorResponse from "../ErrorResponse";
import moment from "moment/min/moment-with-locales";
import { ArrowDown, ArrowUp, GenderFemale, GenderMale } from "react-bootstrap-icons";
import { toAutoDecimals } from "../HelperFunctions";

export default function GenderCard({ data, loading, error }) {
    return (
        <Card>
            <Card.Header className="d-flex align-items-center px-2">
                <span className="flex-grow-1">Gender</span>
            </Card.Header>
            <Card.Body className="d-flex pb-1 flex-column justify-content-center">
                {loading ? (
                    <LoadingIndicator width={85} />
                ) : error ? (
                    <ErrorResponse errorCode={error} />
                ) : (
                    <>
                        <Col className="d-flex gap-3 mb-2 align-items-center">
                            <Col xs="auto" className="d-flex flex-column align-items-center">
                                <GenderMale height={30} width={30} />
                                <span>Male</span>
                            </Col>
                            <Col>
                                <Stack gap={1}>
                                    <ProgressBar className="gender-bar">
                                        <ProgressBar
                                            className="bg-ra-alternative-blue fw-bold fs-7"
                                            label={`${toAutoDecimals(data.male.time_frame, 2)}%`}
                                            now={data.male.time_frame}
                                            key={1}
                                        />
                                        <ProgressBar
                                            className="bg-ra-brown fw-bold fs-7"
                                            label={`${toAutoDecimals(data.female.time_frame, 2)}%`}
                                            now={data.female.time_frame}
                                            key={2}
                                        />
                                    </ProgressBar>
                                    <ProgressBar className="gender-bar avg">
                                        <ProgressBar
                                            className="bg-ra-alternative-blue fw-bold fs-7"
                                            label={`${toAutoDecimals(data.male.average, 2)}% AVG`}
                                            now={data.male.average}
                                            key={1}
                                        />
                                        <ProgressBar
                                            className="bg-ra-brown fw-bold fs-7"
                                            label={`${toAutoDecimals(data.female.average, 2)}% AVG`}
                                            now={data.female.average}
                                            key={2}
                                        />
                                    </ProgressBar>
                                </Stack>
                            </Col>
                            <Col xs="auto" className="d-flex flex-column align-items-center">
                                <GenderFemale height={30} width={30} />
                                <span>Female</span>
                            </Col>
                        </Col>
                        <Col>
                            <Stack direction="horizontal">
                                <Col>
                                    <Stack>
                                        <Stack direction="horizontal" className="fw-bold fs-3 text-center justify-content-center">
                                            {data.tsl_male?.time_frame && data.tsl_male?.average ? (
                                                data.tsl_male.time_frame > data.tsl_male.average ? (
                                                    <ArrowUp className="text-success col-2" />
                                                ) : (
                                                    <ArrowDown className="text-danger col-2" />
                                                )
                                            ) : (
                                                <div className="col-2"></div>
                                            )}
                                            <span>
                                                {data.tsl_male?.time_frame
                                                    ? moment.utc(moment.duration(data.tsl_male.time_frame, "s").asMilliseconds()).format("HH:mm:ss")
                                                    : "--:--:--"}
                                            </span>
                                            <div className="col-2"></div>
                                        </Stack>
                                        <span className="text-center fs-6">TSL per Session</span>
                                        <span className="text-center text-muted fst-italic fs-8">
                                            <span>AVG </span>(
                                            {data.tsl_male?.average
                                                ? moment.utc(moment.duration(data.tsl_male.average, "s").asMilliseconds()).format("HH:mm:ss")
                                                : "--:--:--"}
                                            )
                                        </span>
                                    </Stack>
                                </Col>
                                <div className="vr"></div>
                                <Col>
                                    <Stack>
                                        <Stack direction="horizontal" className="fw-bold fs-3 text-center justify-content-center">
                                            {data.tsl_female?.time_frame && data.tsl_female?.average ? (
                                                data.tsl_female.time_frame > data.tsl_female.average ? (
                                                    <ArrowUp className="text-success col-2" />
                                                ) : (
                                                    <ArrowDown className="text-danger col-2" />
                                                )
                                            ) : (
                                                <div className="col-2"></div>
                                            )}
                                            <span>
                                                {data.tsl_female?.time_frame
                                                    ? moment.utc(moment.duration(data.tsl_female.time_frame, "s").asMilliseconds()).format("HH:mm:ss")
                                                    : "--:--:--"}
                                            </span>
                                            <div className="col-2"></div>
                                        </Stack>
                                        <span className="text-center fs-6">TSL per Session</span>
                                        <span className="text-center text-muted fst-italic fs-8">
                                            <span>AVG </span>(
                                            {data.tsl_female?.average
                                                ? moment.utc(moment.duration(data.tsl_female.average, "s").asMilliseconds()).format("HH:mm:ss")
                                                : "--:--:--"}
                                            )
                                        </span>
                                    </Stack>
                                </Col>
                            </Stack>
                        </Col>
                    </>
                )}
            </Card.Body>
        </Card>
    );
}
